import React from 'react';
import './style.less'

interface Checkpoutprops {}

const Checkout:React.FC<Checkpoutprops> = () => {
    return (
        <div className="Checkout">
            <h1 style={{marginTop:'100px'}}>Checkout</h1>
        </div>
    );
}

export default Checkout;
